export const shouldLoad = () => document.querySelector(`[data-controller="text-expand"]`) !== undefined;
